import { render, staticRenderFns } from "./PurchaseOrderItem.vue?vue&type=template&id=7670decd"
import script from "./PurchaseOrderItem.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports